import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import {formatToIntegerValue} from "../../../../common/utils";
import {useOrderInvoiceFormContext} from "../../contexts/OrderInvoiceFormContext";

const FieldIdNumber = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'orderInvoice-form-idNumber',
    defaultMessage: 'ID Number'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField({name: 'idNumber'});
  const {showAllErrors} = useOrderInvoiceFormContext();

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      onChange={e => {
        field.onChange(field.name)(formatToIntegerValue(e));
      }}
      placeholder={placeholder}
      showErrorOnSubmit={showAllErrors}
    />
  );
};

export default FieldIdNumber;
